import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Divider, Rate, Row, Spin } from "antd";
import TrackCard from "../../components/track-card";
import {
  DollarOutlined,
  MoneyCollectOutlined,
  StarOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import TrackImage from "../../assets/track-overview.png";
import TrainerImage from "../../assets/trainer.png";
import ProfessionalCertificateImage from "../../assets/professional-certificate.png";

import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { getTrack } from "../../store/apis/tracks";
import Loader from "../../components/loader";
import { getCourseById } from "../../store/apis/courses";
import TrackCourses from "../../components/trackCourses";
import { useNavigate } from "react-router-dom";
import userOneImage from "../../assets/user1.png";
import userTwoImage from "../../assets/user2.png";
import { subscribeTrack } from "../../store/apis/users";

const { Meta } = Card;

function TrainingTrack() {
  const [trackStatus, setTrackStatus] = useState("");
  const trackState = useSelector((state) => state.tracks.track);
  const user = useSelector((state) => state.user.user);
  const courseState = useSelector((state) => state?.courses?.trackCourses);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const trackId = window.location.pathname.split("/")[2];
    dispatch(getTrack(trackId));
  }, []);

  useEffect(() => {
    if (user.paidTracks && user.paidTracks?.length) {
      const checkTrack = user.paidTracks.find(
        (item) => item.trackId == trackState?._id
      );
      setTrackStatus(checkTrack?.status);
    } else {
      setTrackStatus("");
    }
  }, [trackState]);

  useEffect(() => {
    if (user && user?._id) {
      if (!courseState?.length) {
        if (trackState?.trackcourses?.length) {
          for (let i = 0; i < trackState?.trackcourses.length; i++) {
            const element = trackState?.trackcourses[i];
            dispatch(getCourseById(element?.courseId));
          }
        }
      }
    }
  }, [trackState?.trackcourses?.length]);

  const handelSubscribeTrack = (trackId) => {
    if (user && user?._id) {
      console.log("trackStatustrackStatus", trackStatus);
      if (trackStatus == "paid") {
        navigate(`/track/${trackId}/courses`);
      } else if (trackStatus == "pending" || !trackStatus) {
        navigate(`/payment/${trackId}`);
      } else {
        navigate(`/track/${trackId}`);
      }
    } else {
      navigate(`/login`);
    }
  };

  const renderTrackHead = () => {
    return (
      <div className="track-head">
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="head-description">
              <h2> {trackState.title} </h2>
              <p>{trackState.description}</p>
              {/* <span> المدرب : {trackState.trainer} </span> */}
              <span>م. محمد الطويل</span>
              <Button
                type="primary"
                onClick={() => handelSubscribeTrack(trackState?._id)}
              >
                {trackStatus == "pending" || !trackStatus
                  ? "إنضم الأن"
                  : "تصفح المسار"}
              </Button>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="head-image">
              <img
                src={
                  trackState.thumnil != ""
                    ? `https://golancer.tech/admin/file/${trackState?.thumnil}`
                    : TrackImage
                }
                crossorigin="anonymous"
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const renderTrackDetails = () => {
    return (
      <div className="track-details">
        <Row justify="center">
          <Col
            xs={24}
            sm={24}
            md={4}
            lg={4}
            xl={4}
            className="track-details-item"
          >
            <div>
              <h3> 100٪ ذاتية </h3>
              <p> تعلم في وقتك الخاص </p>
            </div>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={5}
            lg={5}
            xl={5}
            className="track-details-item"
          >
            <div>
              <h3> مستوى مبتدئ </h3>
              <p> لا يشترط وجود خبرة سابقة. </p>
            </div>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={5}
            lg={5}
            xl={5}
            className="track-details-item"
          >
            <div>
              <h3> اللغة العربية </h3>
              <p> الترجمة : عربية </p>
            </div>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={5}
            lg={5}
            xl={5}
            className="track-details-item"
          >
            <div>
              <h3> 6 اشهر </h3>
              <p> أقل من 10 ساعات دراسية في الأسبوع </p>
            </div>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={5}
            lg={5}
            xl={5}
            className="track-details-item"
          >
            <div>
              <div className="track-rate">
                <h3> 4.8\5 </h3>
                <StarOutlined />
              </div>
              <p>
                69183 تقييمًا <br />
                892383 مسجل بالفعل
              </p>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const renderTrackImproveSkills = () => {
    return (
      <div className="tracking-improve-skills">
        <Row>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <div className="tracking-improve-skills-description1">
              <h2>قم ببناء مهارات الاستعداد للعمل من خلال التعلم من الأفضل</h2>
              <p>
                ابدأ في مجال صناعة تطبيقات الهواتف الذكية والتي تعمل على جميع
                المنصات و أنظمة التشغيل، باستخدام اطار عمل فلاتر المطلوب بشهادة
                احترافية من قولانسر .
              </p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <div className="tracking-improve-skills-description">
              <h2> $73,000 </h2>
              <p> متوسط الراتب على مستوى الدخول¹ </p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <div className="tracking-improve-skills-description">
              <h2> 75% </h2>
              <p>من خريجي شهادات قولانسر يبلغون عن تحسن مهنتهم²</p>
            </div>
          </Col>
          {/*  */}
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <div className="tracking-improve-skills-description1">
              <h2> المسميات الوظيفية الشائعة </h2>
              <p>
                مبرمج تطبيقات هواتف ذكية ، مبرمج دارت ، مبرمج فلاتر ، مصمم
                تطبيقات الهواتف ، مبرمج تطبقات اندرويد و أيفون ، مطور تطبيقات
                الهواتف .
              </p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <div className="tracking-improve-skills-description">
              <h2> 479,000 </h2>
              <p> فرص عمل عند الطلب في برمجة الهواتف الذكية </p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <div className="tracking-improve-skills-description">
              <h2> 150+ </h2>
              <p>
                تواصل مع أكثر من 150 صاحب عمل في الولايات المتحدة بعد الانتهاء
              </p>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const renderSkillsYouGot = () => {
    const data = [
      "البرمجة بإستخدام لغة دارت",
      "Application Programming Interfaces (API)",
      "Github",
      "App Development",
      "Github",
      "App Development",
      "futter (App Framework)",
      "Getx",
      "Database (DBMS)",
      "MySQL",
      "App Development",
    ];
    return (
      <div className="skills-you-got">
        <div>
          <h2> المهارات التي ستكتسبها </h2>
        </div>
        <div className="skills-sections">
          {data.map((item) => {
            return (
              <div className="item-card" key={item}>
                <span> {item} </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderAboutTrainer = () => {
    return (
      <div className="about-trainer">
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="about-trainer-image">
              <img
                src={
                  courseState && courseState?.length
                    ? `https://golancer.tech/admin/file/${courseState[0]?.trainerImage}`
                    : TrainerImage
                }
                crossorigin="anonymous"
              />
              <div className="about-trainer-image-desc">
                <span>
                  {courseState && courseState?.length
                    ? courseState[0]?.trainer
                    : "محمد الطويل"}
                </span>

                {/* <p> مدير التسويق والمبيعات بشركة أكسون موبيل سابقًا </p> */}
              </div>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="about-trainer-description">
              <h2> عن المدرب </h2>
              <p>
                {courseState && courseState?.length
                  ? courseState[0]?.aboutTrainer
                  : "..محمد مهندس برمجيات ولديه 5 سنوات من الخبرة في تطوير برمجيات الهواتف الذكية عمل كمهندس مستقل وبنى مشاريع لشركات وأفراد في دول  متعددة مثل كندا والمملكة العربية السعودية. الدورات التدريبية"}
              </p>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const renderWorkAward = () => {
    const peopleOptions = [
      {
        img: userOneImage,
        text: "كانت قولانسر لا تقدر بثمن بالنسبة لأعمالي وتطوراتي الشخصية. ساعدتني الدورات على تحسين مهاراتي في البرمجة وتحصيل الوظائف.",
      },
      {
        img: userTwoImage,
        text: "ساعدتني الدورات المقدمة من قو لانسر على تعلم  أهم مهارات البرمجة، كما واستفدت كثيرا من عملية التوجيه المباشر عند استصعابي لبعض محاور الدورة.",
      },
    ];

    return (
      <div>
        <div className="work-award-section">
          <div className="work-award-section-title">
            <h2> حول هذه الشهادة المهنية </h2>
          </div>
          <Row>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="work-award-description">
                <h2> 55473 مشاهدة حديثة </h2>
                <p>
                  هل أنت مستعد لاكتساب مهارات جديدة والأدوات التي يستخدمها
                  المطورون لإنشاء مواقع الويبوتطبيقات الهواتف؟ هذه الشهادة ،
                  التي صممها خبراء هندسة البرمجيات في قولانسر ستجهزك لمهنة
                  مبتدئة كمطور تطبيقات هواتف ذكية.
                  <br />
                  عند الانتهاء ، ستحصل على إمكانية للتقديم على الوظائف من منصات
                  العمل الحروهي منصات للبحث عن الوظائف تربطك بالأف من أصحاب
                  العمل عمل بالإضافة إلى موارد الدعم الوظيفي لمساعدتك في وظيفتك
                  بحث.
                </p>
              </div>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="work-award-description">
                <h2> في هذا البرنامج ، ستتعلم:</h2>
                <ul>
                  <li>
                    اطار العمل فلاتر الأكثر شيوعاً لبناء تطبيقات الهواتف الذكية
                    التي تعمل على مختلف أنظمة التشغيل .
                  </li>
                  <li>
                    مهارات البرمجة الأكثر طلباً و كيفية استخدام الأكواد البرمجية
                    بثقة لحل المشكلات.
                  </li>
                  <li> أوامر Linux ومستودعات Git لتنفيذ التحكم في الإصدار.</li>
                  <li>
                    عالم تخزين البيانات وقواعد البيانات باستخدام MySQL ، وكيفية
                    صياغة استعلامات SQL متطورة.
                  </li>
                  <li>
                    إطار عمل ويب Django وكيف تستهلك الواجهة الأمامية البيانات من
                    REST APIs.
                  </li>
                  <li>
                    {" "}
                    كيفية التحضير للمقابلات الفنية لأدوار المطور الخلفي.{" "}
                  </li>
                </ul>
              </div>
            </Col>
            {/*  */}
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="work-award-description">
                <h2> مشاريع التعليم بالتطبيق </h2>
                <p>
                  خلال البرنامج ، ستشارك في التعلم التطبيقي من خلال الأنشطة
                  العملية للمساعدة في رفع مستوى معرفتك. في نهاية كل دورة ، ستكمل
                  10 مشاريع صغيرة ستساعدك في إعدادك للخطوات التالية في رحلتك
                  المهنية كمهندس.
                </p>
              </div>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="work-award-description">
                <h2>
                  في هذه المشاريع ، ستستخدم بيئة معملية أو تطبيق ويب لأداء مهام
                  مثل:
                </h2>
                <ul>
                  <li>حل المشاكل باستخدام كود دارت.</li>
                  <li>
                    إدارة مشروع في GitHub باستخدام التحكم في الإصدار في مستودعات
                    Git و Git و Linux Terminal.
                  </li>
                  <li>تصميم وبناء تطبيق Django بسيط. </li>
                </ul>
              </div>
            </Col>
          </Row>
          <div className="work-award-footer">
            <p>
              في نهاية البرنامج ، سيكون هناك مشروع Capstone حيث ستجمع كل معارفك
              معًا لإنشاء تطبيق هاتف Flutter.
            </p>
          </div>
        </div>
        {/*  */}
        <div className="people-opinions-container">
          <Row>
            {peopleOptions?.map((item) => {
              return (
                <Col xs={24} sm={24} md={12} lg={12} xl={12} key={item.img}>
                  <Card
                    // hoverable
                    cover={
                      <img
                        style={{ width: 200 }}
                        alt="example"
                        src={item.img}
                      />
                    }
                  >
                    <Meta description={item.text} />
                  </Card>
                </Col>
              );
            })}
          </Row>
        </div>
      </div>
    );
  };

  const renderProfessionalCertificate = () => {
    return (
      <div className="professional-certificate-container">
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="professional-certificate-description">
              <h2>ما هي الشهادة المهنية؟ </h2>
              <h3>بناء المهارات للاستعداد للوظيفة</h3>
              <p>
                سواء كنت تتطلع إلى بدء مهنة جديدة ، أو تغيير مهنتك الحالية ،
                تساعدك الشهادات الاحترافية على قولانسر في أن تصبح جاهزًا للعمل.
                تعلم بالسرعة التي تناسبك ، في أي وقت وفي أي مكان يناسبك. سجّل
                اليوم واستكشف مسارًا وظيفيًا جديدًا مع إصدار تجريبي مجاني لمدة 7
                أيام. يمكنك إيقاف تعلمك مؤقتًا أو إنهاء اشتراكك في أي وقت.
              </p>
            </div>
            <div className="professional-certificate-description">
              <h3> التدريب العملي على المشاريع </h3>
              <p>
                قم بتطبيق مهاراتك من خلال المشاريع العملية وقم ببناء محفظة تعرض
                استعدادك الوظيفي لأصحاب العمل المحتملين. ستحتاج إلى إنهاء
                المشروع (المشاريع) بنجاح للحصول على شهادتك.
              </p>
            </div>
            <div className="professional-certificate-description">
              <h3> احصل على اعتماد مهني </h3>
              <p>
                عندما تكمل جميع الدورات في البرنامج ، ستحصل على شهادة لمشاركتها
                مع شبكتك المهنية بالإضافة إلى فتح الوصول إلى موارد الدعم الوظيفي
                لمساعدتك على بدء حياتك المهنية الجديدة. لدى العديد من الشهادات
                المهنية شركاء توظيف يتعرفون على بيانات اعتماد الشهادة الاحترافية
                ويمكن للآخرين المساعدة في إعدادك لامتحان الشهادة. يمكنك العثور
                على مزيد من المعلومات حول صفحات الشهادة الاحترافية الفردية حيثما
                ينطبق ذلك.
              </p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="professional-certificate-image">
              <img src={ProfessionalCertificateImage} />
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const renderCoursesTrack = () => {
    let trackcourses;
    if (trackState?.trackcourses) {
      trackcourses = trackState?.trackcourses;
    }
    return (
      <div className="courses-track-container">
        <div className="courses-track-section-title">
          <h2>هناك {courseState?.length} دورات في هذه الشهادة المهنية</h2>
        </div>
        {courseState?.map((item, index) => {
          return (
            <div className="course-step" key={item.courseStep}>
              <a href={`/course/${item?._id}`}>
                <Row>
                  <Col
                    xs={24}
                    sm={24}
                    md={2}
                    lg={2}
                    xl={2}
                    className="courses-track-description-ant-Col"
                  >
                    <div className="courses-track-title">
                      <p> الكورس </p>
                      <span> {index + 1} </span>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={20} lg={20} xl={20}>
                    <div className="courses-track-description">
                      <h3> {item?.title} </h3>
                      <div className="rate-desc">
                        <Rate disabled value={item?.courseRating} />
                        <p>
                          {item?.courseRating} نجوم <br />
                        </p>
                      </div>
                      <p>{item.description}</p>
                    </div>
                  </Col>
                </Row>
              </a>
            </div>
          );
        })}
      </div>
    );
  };

  return trackState ? (
    <div className="track-container">
      {renderTrackHead()}
      {renderTrackDetails()}
      {renderTrackImproveSkills()}
      {renderSkillsYouGot()}
      {renderAboutTrainer()}
      {renderWorkAward()}
      {renderProfessionalCertificate()}
      {courseState && courseState?.length && trackStatus == "paid"
        ? renderCoursesTrack()
        : ""}
      {/* <TrackCourses /> */}
    </div>
  ) : (
    <Loader />
  );
}

export default TrainingTrack;
